import React from 'react';
import { noop } from 'lodash';
import cn from 'classnames';
import { VARIATIONS_PREVIEW_CARD } from '../../../propTypes';
import Variation from '../../base/Variation';
import './style.scss';

const VariationsPreviewCard = ({
    variations = [],
    moreCounter = 0,
    target,
    variationsURL,
    onClick = noop,
    activeIndex,
    onMouseEnter = noop,
    onMouseLeave = noop,
    onLoadMoreVariationsClick = noop,
}) => (
    <div className="variations-preview-card">
        {variations.map((variation, index) => (
            <div
                className={cn('variation-preview', { active: activeIndex === index })}
                key={variation.id}
                onMouseEnter={() => onMouseEnter(index)}
                onMouseLeave={onMouseLeave}
            >
                <Variation {...variation} onClick={() => onClick(index)} />
            </div>
        ))}
        {moreCounter > 0 && (
            <a
                className="variation-preview load-more no-under-line"
                href={variationsURL}
                onClick={onLoadMoreVariationsClick}
                target={target}
                rel="noopener"
            >
                +{moreCounter}
            </a>
        )}
    </div>
);

VariationsPreviewCard.propTypes = VARIATIONS_PREVIEW_CARD;

export default VariationsPreviewCard;
